import { render, staticRenderFns } from "./AdminLabs.vue?vue&type=template&id=c2f10034&scoped=true&"
import script from "./AdminLabs.vue?vue&type=script&lang=js&"
export * from "./AdminLabs.vue?vue&type=script&lang=js&"
import style0 from "./AdminLabs.vue?vue&type=style&index=0&id=c2f10034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f10034",
  null
  
)

export default component.exports